var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUaeFlag = function SvgUaeFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 13.786,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    rx: 1.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "uaeFlag_svg__a",
    width: 20,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 13.786,
    x: 0.25,
    y: 0.25,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1.75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#uaeFlag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12833B",
    d: "M5.714 4.762H20V0H5.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M5.714 14.286H20V9.524H5.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF323E",
    d: "M0 14.286h5.714V0H0z"
  }))));
};
export default SvgUaeFlag;